import { React, useState } from 'react';
import CustomButton from '../CustomButton';

import './style.css'

const NotificationCard = (props) => {

    const [isRead, setIsRead] = useState(!!props.read)

    return (
        <div className={`notificationWrapper ${isRead ? 'notificationRead' : 'notificationUnread'}`}>
            <div className={`d-sm-flex justify-content-between align-items-center gap-3 `} key={props.id}>
                <div className="d-flex gap-3">
                    <div className="notificationImageIcon">
                        <img src={props?.image} alt="Icon"/>
                    </div>
                    <div className="flex-grow-1">
                        <p className="notificationText">{props?.text}</p>
                        <div className="dateTime">
                            <p className="p-sm l-grey-text mb-0">{props?.date}</p>
                            <span className='mx-2'>|</span>
                            <p className="p-sm l-grey-text mb-0">{props?.time}</p>
                        </div>
                    </div>
                </div>
                <div className="flex-shrink-0 text-end">
                    <CustomButton onClick={() => setIsRead(!isRead)} variant={isRead ? 'secondaryButton' : 'primaryButton'} className="customButton2 notificationAction" text={isRead ? "Mark unread" : "Mark read"} />
                </div>
            </div>
        </div>

    )
}

export default NotificationCard
